import { motion } from "framer-motion";
import { APPS, PHASES } from "@/data/content";
import { Reveal, MaskLine, Eyebrow } from "./Reveal";
import { scrollToId } from "./SmoothScroll";
import { selectSuiteApp } from "./Suite";

const open = (id) => { selectSuiteApp(id); scrollToId("aplicativos"); };

export const Lifecycle = () => (
  <section id="ciclo" data-testid="lifecycle-section" className="relative bg-[var(--ink)] py-24 md:py-32 overflow-hidden">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <Reveal><Eyebrow testid="lifecycle-eyebrow">Do cálculo à manutenção</Eyebrow></Reveal>
      <h2 className="mt-6 font-display font-black uppercase text-5xl md:text-7xl leading-[0.9] max-w-4xl">
        <MaskLine inView>Uma suíte para</MaskLine>
        <MaskLine inView delay={0.1}><span className="steel-text">todo o ciclo do ativo.</span></MaskLine>
      </h2>

      <div className="relative mt-16 grid sm:grid-cols-2 lg:grid-cols-4 border-t border-white/10">
        {PHASES.map((p, i) => (
          <motion.div
            key={p.id}
            data-testid={`phase-${p.id}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, delay: i * 0.1 }}
            className="relative border-b sm:border-r border-white/10 p-6 lg:p-8 last:border-r-0"
          >
            <span className="absolute -top-[5px] left-6 lg:left-8 h-2.5 w-2.5 rounded-full bg-[var(--cyan)] shadow-[0_0_16px_rgba(95,212,255,0.8)]" />
            <span className="font-mono text-sm text-[var(--cyan)]">{p.n}</span>
            <h3 className="mt-3 font-display text-4xl font-black uppercase text-white">{p.title}</h3>
            <p className="mt-3 text-sm text-[var(--steel-2)] leading-relaxed min-h-[3rem]">{p.text}</p>
            <div className="mt-6 space-y-2">
              {APPS.filter((a) => a.phase === p.id).map((a) => (
                <button key={a.id} data-testid={`phase-app-${a.id}`} onClick={() => open(a.id)}
                  className="group flex w-full items-center gap-3 rounded-sm border border-white/10 bg-[var(--navy)]/60 px-3 py-2.5 text-left hover:border-[var(--cyan)]/50 transition-colors">
                  <img src={a.logo} alt="" className="h-9 w-9 object-contain" />
                  <span className="flex-1">
                    <span className="block text-sm font-medium text-white">{a.name}</span>
                    <span className="block text-xs text-[var(--steel-2)]">{a.tagline}</span>
                  </span>
                  <span className="text-[var(--steel-2)] transition-transform group-hover:translate-x-1">→</span>
                </button>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
